import { Avatar as BaseAvatar, AvatarProps as BaseAvatarProps } from 'antd'

export interface AvatarProps extends BaseAvatarProps {}

export const Avatar = (props: AvatarProps): JSX.Element => (
  <>
    <BaseAvatar {...props} />
  </>
)
